import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import styles from "../../SiteManagement/styles"; //TODO export these further up!
import {
  Button,
  Container,
  Typography,
} from "@mui/material";
import DeleteModal from "../Common/DeleteModal";
import { LTIPlatformDTO } from "@beable/roster-backend-client-v1";
import { SUBPAGES } from "../constants";
import LTIConfigModal from "./LTIConfigModal";
import AddLTIPlatformModal from "./AddLTIPlatformModal";
import EditLTIPlatformModal from "./EditLTIPlatformModal";

interface SSOLTIPlatformActionsProps {
  selectedItem?: LTIPlatformDTO;
  onActionComplete: (success: boolean) => void;
}

export default function SSOLTIPlatformActions({
  selectedItem,
  onActionComplete,
}: SSOLTIPlatformActionsProps) {
  const theme = useTheme();
  const classes = styles.pageStyles(theme);

  const [displayModal, setDisplayModal] = useState<
    "add" | "edit" | "delete" | undefined
  >();
  const [LTIConfigModalOpened, setLTIConfigModalOpened] = React.useState(false);

  const closeModal = (success: boolean) => {
    setDisplayModal(undefined);
    onActionComplete(success);
  };

  const formatText = (item: LTIPlatformDTO) => {
    let label = item?.name;
    if (item.environment) label += ` (${item.environment})`;
    return label.length ? label : "unknown";
  };

  return <>
    <Container sx={classes.dfb}>
      <Button
        sx={classes.verticalBtn}
        variant="contained"
        color="primary"
        onClick={() => setDisplayModal("add")}
      >
        Add new LTI platform
      </Button>
      <Button
        sx={classes.verticalBtn}
        variant="contained"
        color="primary"
        onClick={() => setLTIConfigModalOpened(true)}
      >
        Get LTI Config
      </Button>
    </Container>
    {selectedItem?.id ? (
      <>
        <Typography variant="h5" sx={{ margin: "16px" }}>
          Options{" "}
          {selectedItem.id !== "" ? `for ${formatText(selectedItem)}` : ""}
        </Typography>
        <Container sx={classes.dfb}>
          <Button
            sx={classes.verticalBtn}
            variant="contained"
            color="secondary"
            onClick={() => setDisplayModal("edit")}
          >
            Edit
          </Button>
          <Button
            sx={[classes.verticalBtn, classes.plainBtn]}
            variant="contained"
            onClick={() => setDisplayModal("delete")}>
            Delete
          </Button>
        </Container>
      </>
    ) : undefined}
    <AddLTIPlatformModal
      open={displayModal === "add"}
      handleClose={closeModal}
    />
    <LTIConfigModal
      open={LTIConfigModalOpened}
      handleClose={() => setLTIConfigModalOpened(false)}
    />
    {selectedItem ? (
      <>
        <EditLTIPlatformModal
          open={displayModal === "edit"}
          handleClose={closeModal}
          LTIPlatformItem={selectedItem}
        />
        <DeleteModal
          open={displayModal === "delete"}
          handleClose={closeModal}
          subpage={SUBPAGES.LTIProviders.value}
          item={selectedItem}
          name={selectedItem.name}
        />
      </>
    ) : undefined}
  </>;
}